import { AA_TEXT, contrastRatio, readableForeground } from './contrast'

/**
 * L'encre réellement posée sur un fond de marque (#99).
 *
 * L'encre choisie par l'organisation est gardée tant qu'elle est lisible sur
 * son fond (AA, 4,5:1) ; sinon — ou si elle est vide — c'est la plus lisible
 * des deux encres neutres qui s'applique. Partagée par le web et l'API : l'un
 * l'applique à l'affichage, l'autre la sert et refuse d'enregistrer pire.
 */
export function effectiveInk(background?: string | null, chosen?: string | null): string | null {
  if (!background) return null
  const computed = readableForeground(background)
  if (!computed) return null
  if (!chosen) return computed
  const ratio = contrastRatio(chosen, background)
  return ratio != null && ratio >= AA_TEXT ? chosen : computed
}
